// extracted by mini-css-extract-plugin
export var sliderRange = "_p5-2";
export var sliderRoot = "_p5-0";
export var sliderThumb = "_p5-3";
export var sliderTrack = "_p5-1";